// Using Knowledge Builder proxy service for centralized API calls

// import {
//     knowledgeBuilderHttpClient, knowledgeBuilderHttpClientWithCreds
// } from 'shared/api/clients/knowledgeBuilder.httpClient';

// class KBWebsocketService {
//     async get_l1_task_id_with_creds(data) {
//         const response = await knowledgeBuilderHttpClientWithCreds.post('/L1/process_from_cos', data);
//         return response;
//     }

//     async l2_processing(data) {
//         const response = await knowledgeBuilderHttpClient.post('/L2/process', data);
//         return response;
//     }
// }

// const kbWSService = new KBWebsocketService();
// export { kbWSService };

import {
    knowledgeBuilderService
} from 'shared/api';
class KBWebsocketService {
    async get_l1_task_id_with_creds(data) {
        const response = await knowledgeBuilderService.performRequestWithFullResponse('v2/kb/api/v1/L1/process_from_cos', {
            method: 'POST',
            data
        });
        return response;
    }

    async l2_processing(data) {
        const response = await knowledgeBuilderService.performRequestWithFullResponse('v2/kb/api/v1/L2/process', {
            method: 'POST',
            data
        });
        return response;
    }
}

const kbWSService = new KBWebsocketService();
export { kbWSService };